







import Vue from 'vue'
import { mapState } from 'vuex'

import Table from '@/components/Card/Thing/Table.vue'
import { IStateThing, ISerial } from '@/store/modules/thing'
import { REFRESH_SIGNAL_MS } from '@/utils/constants'

export default Vue.extend({
  components: {
    Table
  },
  data() {
    return {
      timeout: 0
    }
  },
  methods: {
    getThing() {
      const hasSerial = this.$store.state.thing.serial !== null
      if (!hasSerial) return

      this.$store.dispatch('thing/getThing').finally(() => {
        this.timeout = setTimeout(this.getThing, REFRESH_SIGNAL_MS)
      })
    }
  },
  computed: {
    ...mapState<IStateThing>('thing', {
      serial: (state: IStateThing) => state.serial
    })
  },
  watch: {
    serial: function() {
      clearTimeout(this.timeout)
      this.$store.commit('thing/resetThing')
      this.getThing()
    }
  },
  mounted() {
    clearTimeout(this.timeout)
    this.getThing()
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
  }
})
